<template>
  <div>
    <!-- Collection list  -->
    <ul class="social-link-list">
      <li>
        <!-- INSTAGRAM LINK-->
        <a href="https://www.instagram.com/grin_works/?hl=en" target="_blanc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="23.995"
            viewBox="0 0 24 23.995"
          >
            <path
              id="Icon_awesome-instagram"
              data-name="Icon awesome-instagram"
              d="M12,8.083a6.152,6.152,0,1,0,6.152,6.152A6.142,6.142,0,0,0,12,8.083Zm0,10.151a4,4,0,1,1,4-4,4.007,4.007,0,0,1-4,4Zm7.838-10.4A1.435,1.435,0,1,1,18.4,6.4,1.432,1.432,0,0,1,19.836,7.831ZM23.91,9.288A7.1,7.1,0,0,0,21.972,4.26a7.148,7.148,0,0,0-5.028-1.938c-1.981-.112-7.919-.112-9.9,0A7.137,7.137,0,0,0,2.017,4.255,7.124,7.124,0,0,0,.079,9.282c-.112,1.981-.112,7.919,0,9.9A7.1,7.1,0,0,0,2.017,24.21a7.157,7.157,0,0,0,5.028,1.938c1.981.112,7.919.112,9.9,0a7.1,7.1,0,0,0,5.028-1.938,7.148,7.148,0,0,0,1.938-5.028c.112-1.981.112-7.913,0-9.894Zm-2.559,12.02a4.049,4.049,0,0,1-2.281,2.281c-1.579.626-5.327.482-7.073.482s-5.5.139-7.073-.482a4.049,4.049,0,0,1-2.281-2.281c-.626-1.579-.482-5.327-.482-7.073s-.139-5.5.482-7.073A4.049,4.049,0,0,1,4.925,4.881C6.5,4.255,10.252,4.4,12,4.4s5.5-.139,7.073.482a4.049,4.049,0,0,1,2.281,2.281c.626,1.579.482,5.327.482,7.073S21.978,19.734,21.351,21.308Z"
              transform="translate(0.005 -2.238)"
              fill="#7a7f8c"
            />
          </svg>
        </a>
      </li>
      <li>
        <!-- BEHANCE LINK -->
        <a href="https://www.behance.net/Grinn" target="_blanc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="38.283"
            height="24"
            viewBox="0 0 38.283 24"
          >
            <path
              id="Icon_awesome-behance"
              data-name="Icon awesome-behance"
              d="M15.42,16.055a5.044,5.044,0,0,0,3.217-4.918c0-4.692-3.5-5.836-7.53-5.836H0V28.856H11.418c4.28,0,8.3-2.054,8.3-6.839,0-2.958-1.4-5.144-4.3-5.962ZM5.178,9.323h4.858c1.868,0,3.549.525,3.549,2.692,0,2-1.309,2.8-3.157,2.8H5.178v-5.5Zm5.536,15.533H5.178V18.368H10.82c2.28,0,3.722.95,3.722,3.363,0,2.379-1.721,3.124-3.828,3.124Zm23.827-16H24.99V6.538h9.551v2.32Zm3.742,11.718c0-5.045-2.951-9.252-8.3-9.252-5.2,0-8.727,3.908-8.727,9.026,0,5.31,3.343,8.953,8.727,8.953,4.074,0,6.713-1.834,7.982-5.736H33.83c-.445,1.456-2.28,2.227-3.7,2.227-2.745,0-4.187-1.608-4.187-4.34h12.3C38.263,21.173,38.283,20.874,38.283,20.575ZM25.947,18.5a3.661,3.661,0,0,1,3.888-3.642c2.353,0,3.536,1.382,3.735,3.642Z"
              transform="translate(0 -5.302)"
              fill="#7a7f8c"
            />
          </svg>
        </a>
      </li>
      <li>
        <!-- FACEBOOK LINK -->
        <a href="" target="_blanc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24.146"
            height="24"
            viewBox="0 0 24.146 24"
          >
            <path
              id="Icon_awesome-facebook"
              data-name="Icon awesome-facebook"
              d="M24.709,12.636A12.073,12.073,0,1,0,10.749,24.563V16.126H7.682v-3.49h3.067V9.976c0-3.026,1.8-4.7,4.56-4.7a18.58,18.58,0,0,1,2.7.236v2.97H16.489a1.745,1.745,0,0,0-1.967,1.885v2.266H17.87l-.535,3.49H14.522v8.437A12.077,12.077,0,0,0,24.709,12.636Z"
              transform="translate(-0.563 -0.563)"
              fill="#7a7f8c"
            />
          </svg>
        </a>
      </li>
      <li>
        <!-- EMAIL -->
        <a href="mailto:ibgrin@o2.pl " target="_blanc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.763"
            height="24"
            viewBox="0 0 21.763 24"
          >
            <path
              id="Icon_simple-email"
              data-name="Icon simple-email"
              d="M23.419,11.077a12.377,12.377,0,0,1-.4,2.684,7.769,7.769,0,0,1-1.044,2.358,5.508,5.508,0,0,1-1.77,1.675,4.994,4.994,0,0,1-2.584.637,3.746,3.746,0,0,1-1.869-.457,3.2,3.2,0,0,1-1.263-1.294,4,4,0,0,1-3.386,1.7,3.443,3.443,0,0,1-2.956-1.59,5.2,5.2,0,0,1-.735-1.842,7.942,7.942,0,0,1-.1-2.4A11.16,11.16,0,0,1,8.049,9.6,8,8,0,0,1,9.4,7.35a5.723,5.723,0,0,1,1.86-1.437,5.189,5.189,0,0,1,2.262-.5,7.032,7.032,0,0,1,1.353.115,5.537,5.537,0,0,1,1.05.315,5.677,5.677,0,0,1,.87.459c.265.171.532.348.8.528l-.657,7.559a2.512,2.512,0,0,0,.019.885,1.238,1.238,0,0,0,.27.546.972.972,0,0,0,.438.285,1.626,1.626,0,0,0,1.539-.3,3.279,3.279,0,0,0,.825-1.05,6.761,6.761,0,0,0,.555-1.578,10.825,10.825,0,0,0,.243-1.965,12.556,12.556,0,0,0-.309-3.671A7.3,7.3,0,0,0,19.158,4.7a6.309,6.309,0,0,0-2.436-1.83,8.84,8.84,0,0,0-3.548-.649,7.835,7.835,0,0,0-3.509.765A8.052,8.052,0,0,0,7,5.1a10.177,10.177,0,0,0-1.746,3.19,14.375,14.375,0,0,0-.735,3.974,13.216,13.216,0,0,0,.375,4.055,7.324,7.324,0,0,0,1.482,2.906,6.183,6.183,0,0,0,2.511,1.746,9.63,9.63,0,0,0,3.464.579,11.866,11.866,0,0,0,2.274-.244c.375-.075.73-.165,1.069-.264a8.048,8.048,0,0,0,.921-.33l.475,2.139a5.277,5.277,0,0,1-1.03.51,9.918,9.918,0,0,1-1.218.352A11.882,11.882,0,0,1,12.3,24a13.339,13.339,0,0,1-4.637-.747,8.535,8.535,0,0,1-3.38-2.223,9.334,9.334,0,0,1-2.029-3.67,15.654,15.654,0,0,1-.567-5.095,15.537,15.537,0,0,1,.975-4.889A12.1,12.1,0,0,1,5.006,3.493,10.7,10.7,0,0,1,8.589.93,11.217,11.217,0,0,1,13.229,0a11.711,11.711,0,0,1,4.5.805A8.745,8.745,0,0,1,20.971,3.07a9.294,9.294,0,0,1,1.926,3.5A13.378,13.378,0,0,1,23.419,11.077Zm-12.88,1.47a5.1,5.1,0,0,0,.264,2.53,1.356,1.356,0,0,0,1.3.855,1.441,1.441,0,0,0,.447-.082,1.594,1.594,0,0,0,.514-.309,2.745,2.745,0,0,0,.522-.63,4.834,4.834,0,0,0,.48-1.065l.513-5.873a3.064,3.064,0,0,0-.8-.1,2.759,2.759,0,0,0-1.327.3,2.628,2.628,0,0,0-.94.894,5.249,5.249,0,0,0-.624,1.47,12.467,12.467,0,0,0-.354,2.01Z"
              transform="translate(-1.67)"
              fill="#7a7f8c"
            />
          </svg>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
ul.social-link-list {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin-left: 0.5rem;
    padding: 0;
    display: flex;
    align-items: center;
    a {
      &:hover {
        svg path {
          fill: var(--color-primary);
        }
      }
    }
  }
}
@media screen and (max-width: 700px) {
  ul.social-link-list {
    li {
      margin: 0;
      a {
        svg {
          height: 1rem;
        }
      }
    }
  }
}
</style>
